import { useEffect } from "react"

const usePageLeave = (cb) => {
    useEffect(() => {
        return () => cb()
    }, [])
}

export default usePageLeave